import axios from 'axios'

class FaqService {
  getFaqCategories = () =>
    axios({
      url: 'question-categories/admin/list',
      method: 'GET',
    })

  createFaqCategory = (data) =>
    axios({
      url: 'question-categories/admin',
      method: 'POST',
      data,
    })

  updateFaqCategory = (id, data) =>
    axios({
      url: `question-categories/admin/${id}`,
      method: 'PUT',
      data,
    })

  deleteFaqCategory = (id) =>
    axios({
      url: `question-categories/admin/${id}`,
      method: 'DELETE',
    })

  createFaqItem = (categoryId, data) =>
    axios({
      url: `question-categories/admin/${categoryId}/items`,
      method: 'POST',
      data,
    })

  updateFaqItem = (categoryId, itemId, data) =>
    axios({
      url: `question-categories/admin/${categoryId}/items/${itemId}`,
      method: 'PUT',
      data,
    })

  deleteFaqItem = (categoryId, itemId) =>
    axios({
      url: `question-categories/admin/${categoryId}/items/${itemId}`,
      method: 'DELETE',
    })
}

export default new FaqService()
